import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { Table, TableCell, TableBody, TableRow, TableHead } from '@mui/material';
import TransitionUserGroupListItemComponent from './TransitionUserGroupListItemComponent';
import { get, sequence, over } from '@totalsoft/change-tracking-react';
import { append } from 'ramda';
import IconButton from 'components/common/buttons/IconButton';
import FlexBox from 'components/common/FlexBox';
import { Typography } from '@totalsoft/rocket-ui';
import { FlowPermissionType, useFlowPermissions } from '../hooks';
import { usePermissions } from 'providers/RightsHooks';

const TransitionUserGroupListComponent = ({ flowId, transitionLens, userGroups }) => {
  const { t } = useTranslation();

  const authorizationCode = useFlowPermissions(FlowPermissionType.WRITE);
  const canWrite = usePermissions(authorizationCode);

  const handleAddTransitionUserGroup = useCallback(() => {
    over(
      transitionLens.userGroups,
      append({
        flowId: flowId,
        transitionId: transitionLens.transitionId |> get,
        groupId: undefined,
        siteId: 0,
        allowed: true
      })
    );
  }, [transitionLens.userGroups, flowId, transitionLens.transitionId]);

  return (
    <>
      <Table>
        <TableHead>
          <TableRow>
            <TableCell>
              <Typography fontWeight='bold'>{t('ApprovalTypes.ApprovalTypeLevelUserGroup.UserGroup')}</Typography>
            </TableCell>
            <TableCell align='right'>
              <Typography fontWeight='bold'>{t('ApprovalTypes.ApprovalTypeLevelUserGroup.Actions')}</Typography>
            </TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {(transitionLens.userGroups |> sequence).map((item, idx) => {
            return (
              <TransitionUserGroupListItemComponent
                transitionLens={transitionLens}
                itemLens={item}
                key={`${item.groupId |> get}_${idx}`}
                index={idx}
                userGroups={userGroups}
              />
            );
          })}
        </TableBody>
      </Table>
      <FlexBox justifyContent='end'>
        <IconButton
          type='add'
          onClick={handleAddTransitionUserGroup}
          disabled={!canWrite || (transitionLens.allowedForAllUserGroups |> get)}
        />
      </FlexBox>
    </>
  );
};

TransitionUserGroupListComponent.propTypes = {
  flowId: PropTypes.number,
  transitionLens: PropTypes.object,
  userGroups: PropTypes.array.isRequired
};

export default React.memo(TransitionUserGroupListComponent);
